import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';

@Component({
  selector: 'switch',
  template: require('./switch.component.html')
})
export class SwitchComponent implements OnInit {
  @Output()
  emitToggle = new EventEmitter();
  @Input() isTrue: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() hasSwitchMarginLeftAuto: boolean = false;

  @Input() class: string = 'switch-container';

  constructor() {}

  toggleSwitch(): void {
    this.emitToggle.emit();
  }

  ngOnInit() {}
}